import styled from 'styled-components'

export const Icon = styled.img`
  display: inline-block;
  margin-right: 0.6rem;
`
